import React, { useState } from 'react'
import { FormModal } from 'components/FormModal'
import OrganizationDetailsScreen from './OrganizationDetailsScreen'
import OrganizationSettingsScreen from './OrganizationSettingsScreen'
import { OrganizationFormData } from 'organization/types'

export const AddOrganizationPrompt = (props: {
  showing: boolean
  complete: (...props: any) => Promise<any>
  cancel: () => Promise<any>
  close: () => void
  initialValue: OrganizationFormData
}) => {
  const { showing, complete, cancel, close, initialValue } = props
  const [formData, setFormData] = useState(initialValue)
  const [screen, setScreen] = useState(0)

  const handleChange = (updates: any) => {
    setFormData((prev: any) => ({ ...prev, ...updates }))
  }

  const handleDetailsSubmit = async (values: any) => {
    handleChange(values)
    setScreen(1)
  }

  const handleSettingsSubmit = async (values: any) => {
    const fullData = { ...formData, ...values }
    await complete(fullData)
  }

  return (
    <FormModal
      id={'trip-prompt'}
      showing={showing}
      close={close}
      title={screen === 0 ? 'Organization Details' : 'Organization Settings'}
    >
      {
        [
          <OrganizationDetailsScreen
            formData={formData}
            buttonsProps={{
              nextButton: { onClick: handleDetailsSubmit, caption: 'Next' },
              backButton: { onClick: cancel, caption: 'Cancel' },
            }}
          />,
          <OrganizationSettingsScreen
            formData={formData}
            buttonsProps={{
              nextButton: { onClick: handleSettingsSubmit, caption: 'Sumbit' },
              backButton: { onClick: () => setScreen(0), caption: 'Back' },
            }}
          />,
        ][screen]
      }
    </FormModal>
  )
}
